import React from "react";
import "./Phonedirectory.css";
import Table from "../../components/Table/Table";
import Underline from "../../widgets/Underline/Underline";


const PhoneDirectory = () => {


  const columns = [
    {
      field: "sno",
      header: "S.No",
    },
    {
      field: "service",
      header: "Place / Service",
    },
    {
      field: "phone",
      header: "Current Phone",
    },
    {
      field: "source",
      header: "Source",
    },
  ];


  

  const emergencyData = [
    {
      sno: 1,
      service: "Unified emergency – Police / Fire / Medical",
      phone: "112",
      source: "Govt. of India – ERSS 112",
    },
    {
      sno: 2,
      service: "Emergency ambulance – Tamil Nadu",
      phone: "108",
      source: "Tamil Nadu Health Systems Project",
    },
    {
      sno: 3,
      service: "Police emergency",
      phone: "112",
      source: "Govt. of India – ERSS 112",
    },
    {
      sno: 4,
      service: "Fire & Rescue emergency",
      phone: "112",
      source: "Govt. of India – ERSS 112",
    },
    {
      sno: 5,
      service: "Child Helpline",
      phone: "1098",
      source: "National Portal of India",
    },
    {
      sno: 6,
      service: "Women Helpline",
      phone: "1091",
      source: "Karaikudi City Municipal Corporation",
    },
  ];


  

  const campusData = [
    {
      sno: 1,
      service:
        "ACGCET – Alagappa Chettiar Government College of Engineering & Technology",
      phone: "04565-224535",
      source: "Sivaganga District Govt.",
    },
    {
      sno: 2,
      service: "ACGCET alternate / direct office",
      phone: "04565-224528",
      source: "Anna University / institutional college data",
    },
    {
      sno: 3,
      service: "CSIR–CECRI, Karaikudi – main",
      phone: "04565-241241 / 227778",
      source: "Official CSIR-CECRI",
    },
    {
      sno: 4,
      service: "CECRI – PS to Director",
      phone: "04565-241501 / 241502",
      source: "Official CSIR-CECRI Key Contacts",
    },
    {
      sno: 5,
      service: "CECRI – Administration",
      phone: "04565-241222 / 241224",
      source: "Official CSIR-CECRI General Administration",
    },
    {
      sno: 6,
      service: "Alagappa University – main",
      phone: "04565-223100",
      source: "Official Alagappa University",
    },
    {
      sno: 7,
      service: "Alagappa University Science Campus – USIC",
      phone: "04565-223303",
      source: "Official Alagappa University",
    },
  ];


 

  const hospitalData = [
    {
      sno: 1,
      service: "Government Hospital, Karaikudi",
      phone: "04565-220663",
      source: "Sivaganga District Govt.",
    },
    {
      sno: 2,
      service:
        "Government Hospital, Karaikudi – additional district listing",
      phone: "95465-240541 / 220173",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 3,
      service: "K.M.C Hospital – reception / appointments",
      phone: "96888-22044",
      source: "Official K.M.C Hospital",
    },
    {
      sno: 4,
      service: "K.M.C Hospital – emergency",
      phone: "96888-22144",
      source: "Official K.M.C Hospital",
    },
    {
      sno: 5,
      service: "K.M.C Hospital – ambulance",
      phone: "73730-97785",
      source: "Official K.M.C Hospital",
    },
    {
      sno: 6,
      service: "Apollo Reach Hospital, Karaikudi",
      phone: "08069-049764 / 04565-223700",
      source: "Official Apollo Hospitals",
    },
    {
      sno: 7,
      service: "Apollo Reach Hospital – additional line",
      phone: "04565-223711",
      source: "Official Apollo Hospitals",
    },
    {
      sno: 8,
      service: "Jedaiah Steve Hospital",
      phone: "04565-225598 / 94874-48383 / 94868-74483",
      source: "Official Jedaiah Steve Hospital",
    },
    {
      sno: 9,
      service: "Global Mission Hospital",
      phone: "91169-11644",
      source: "Official Global Mission Hospital",
    },
    {
      sno: 10,
      service: "Global Mission Hospital – appointments",
      phone: "91169-11647",
      source: "Official Global Mission Hospital",
    },
    {
      sno: 11,
      service: "Karaikudi Kidney & Speciality Hospital (KKSH)",
      phone: "04565-283633 / 98437-22515",
      source: "Official KKSH",
    },
    {
      sno: 12,
      service: "Benny Hospital",
      phone: "04565-226906",
      source: "Google Maps business listing ",
    },
    {
      sno: 13,
      service: "CS Multispeciality Hospital",
      phone: "84382-37232",
      source: "Google Maps business listing ",
    },
  ];



  const policeData = [
    {
      sno: 1,
      service: "Karaikudi Police Control Room, Alagappapuram",
      phone: "04565-224375 / 224800",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 2,
      service: "Karaikudi North Police Station",
      phone: "04565-238448",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 3,
      service: "Karaikudi South Police Station",
      phone: "04565-237328",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 4,
      service: "Traffic Police Station",
      phone: "04565-236949",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 5,
      service: "DSP, Karaikudi",
      phone: "04565-238044",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 6,
      service: "Karaikudi Women’s Police Station",
      phone: "04565-238448",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 7,
      service: "Police Station – College Road / Alagappa Puram listing",
      phone: "04565-234616",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
  ];


  
  const fireData = [
    {
      sno: 1,
      service: "Karaikudi Fire Service Station – RF Road",
      phone: "04565-221101",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 2,
      service: "Fire / Rescue emergency",
      phone: "112",
      source: "Govt. of India – ERSS 112",
    },
  ];


  

  const xeroxData = [
    {
      sno: 1,
      service: "Penguin Xerox – University Road, near Alagappa",
      phone: "75400-27003",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
    {
      sno: 2,
      service: "Penguin Xerox – College Road / Subramaniapuram",
      phone: "95516-51216",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
    {
      sno: 3,
      service: "Annai Xerox & eSevai Maiyam – College Road",
      phone: "84891-00896",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
    {
      sno: 4,
      service: "Banu Xerox – Kottaiyur Road",
      phone: "73732-02050",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
    {
      sno: 5,
      service: "Penguin Xerox – 100 Feet Road",
      phone: "89258-54460",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
    {
      sno: 6,
      service: "M.R.R Printers – Railway Road / Alagappa Puram",
      phone: "76959-26871",
      source: "Google Maps business listing (checked 18 Sep 2026)",
    },
  ];


  

  const electricityData = [
    {
      sno: 1,
      service: "TNEB Divisional Engineer – Karaikudi",
      phone: "04565-256295",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 2,
      service: "TNEB Sub-Division – Koviloor / Managiri",
      phone: "04565-238138",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 3,
      service: "TNEB Enquiry",
      phone: "04565-222353",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 4,
      service: "Karaikudi Municipal Corporation",
      phone: "04565-238201",
      source: "Sivaganga District Government – Public Utilities",
    },
    {
      sno: 5,
      service: "Railway Enquiry",
      phone: "04565-222341",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 6,
      service: "Postal Enquiry",
      phone: "04565-222351",
      source: "Karaikudi City Municipal Corporation",
    },
    {
      sno: 7,
      service: "Bharat Gas Agency – Gunapathy",
      phone: "04565-238727",
      source: "Karaikudi City Municipal Corporation",
    },
  ];


  

  const DirectorySection = ({ title, data }) => {
    return (
      <section className="phone-directory-section">

        <div className="phone-directory-section-title">
          <h2>{title}</h2>
        </div>

        <div className="phone-directory-table">
          <Table
            data={data}
            columns={columns}
          />
        </div>

      </section>
    );
  };


  

  return (
    <div className="phone-directory">

      

      <div className="phone-directory-title">
    <Underline heading="Karaikudi Phone Directory" />
</div>


    

      <div className="phone-directory-alert">

        <strong>Important:</strong>

        Government of India's ERSS identifies{" "}
        <strong>112</strong> as the nationwide unified emergency
        number covering police, fire and health emergencies.

        Tamil Nadu's{" "}
        <strong>108</strong> ambulance service is a 24×7 emergency
        ambulance service.

      </div>


    
      <div className="phone-directory-container">

        <DirectorySection
          title="Emergency Services"
          data={emergencyData}
        />

        <DirectorySection
          title="ACGCET / CECRI / Science Campus"
          data={campusData}
        />

        <DirectorySection
          title="Hospitals & Medical Services"
          data={hospitalData}
        />

        <DirectorySection
          title="Police"
          data={policeData}
        />

        <DirectorySection
          title="Fire & Rescue Services"
          data={fireData}
        />

        <DirectorySection
          title="Xerox / Printing / Student Services"
          data={xeroxData}
        />

        <DirectorySection
          title="Electricity / Civic / Transport Services"
          data={electricityData}
        />


      

        
    

      </div>

    </div>
  );
};

export default PhoneDirectory;